import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'booking-reservations',
    component: Children,

    children: [
      {
        path: '',
        component: Children,

        children: [
          {
            path: '',
            name: 'booking-reservations',
            component: () => import('../pages/BookingReservationsPage.vue')
          }
        ]
      }
    ]
  }
];

export default routes;
